import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
    selector: 'app-m-part-selection-modal',
    templateUrl: './m-part-selection-modal.component.html',
    styleUrls: ['./m-part-selection-modal.component.scss']
})
export class MPartSelectionModalComponent implements OnInit {

    public parts: Array<any>;
    public selected: any;

    @Output() onSelect = new EventEmitter();

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<MPartSelectionModalComponent>
    ) {
    }

    ngOnInit() {
        this.parts = [];
        this.selected = null;

        if (this.data.hasOwnProperty('parts') && Array.isArray(this.data.parts)) {
            this.parts = this.data.parts;
        }
    }

    onSelectClick() {
        this.onSelect.emit(this.selected);
        this.closeDialog();
    }

    onCancelClick() {
        this.closeDialog();
    }

    private closeDialog() {
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/modules/mobile/components/part-selection-modal/m-part-selection-modal.component.ts